import React, { useState, useEffect, useContext } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Button, Modal, ModalOverlay, ModalContent, ModalBody, IconButton } from "@chakra-ui/react"
import { Heart, X, MapPin, Briefcase, GraduationCap, Star, MessageCircle, Instagram, Coffee, Camera, Music, Utensils, Plane, Palette, ChevronLeft, ChevronRight, ArrowLeft, Share, ChevronDown, ChevronUp, Mountain, Dumbbell } from 'lucide-react'
import { GetUserById } from "../services/backend"
import { resolveImageUrl, resolveProfileImageUrl } from "../util/profileImage"
import { Center } from "@chakra-ui/react"
import { Spinner } from "@chakra-ui/react"
import ProfileDetailsInterestBadge from "./ui/ProfileDetailsInterestbadge"
import { Loader2Icon } from "lucide-react"
import {CdnButton} from "./ui/CdnButton"
import { BsThreeDots } from "react-icons/bs"
import { useToast } from "@chakra-ui/react"
import { GetLikesNotifications, GetMatchesNotifications } from "../services/backend"
import matchers from "@testing-library/jest-dom/matchers"
import { GlobalContext } from "../store/global_context";
import { ProfileContext } from "../store/profile_context";
import { AddLike } from "../services/backend"
import { useMatchCelebration } from "../context/MatchCelebrationContext"
import { FREE_DAILY_LIKE_LIMIT, isLikeLimitError } from "../util/likeLimit"
import PremiumVerifiedBadge from "./ui/PremiumVerifiedBadge"

  const user = JSON.parse(localStorage.getItem('user'));
// Replace Next.js Image component with regular img tag
const Image = ({ src, alt, fill, className, priority, ...props }) => {
  return (
    // biome-ignore lint/a11y/useAltText: <explanation>
<img 
      src={src || "https://via.placeholder.com/400x600/cccccc/666666?text=Photo"} 
      alt={alt || "Profile Image"} 
      aria-label="Profile Image"
      className={`${fill ? 'absolute inset-0 w-full h-full' : ''} ${className}`}
      {...props}
    />
  )
}

// Sample user data with placeholder images
const userData = {
  name: "Emma",
  age: 28,
  location: "New York, NY",
  distance: "2 miles away",
  occupation: "Product Designer",
  education: "NYU Graduate",
  bio: "Adventure seeker, coffee enthusiast, and dog lover. Looking for someone to explore the city with and share good laughs. Love hiking, trying new restaurants, and weekend getaways.",
  images: [
    "https://via.placeholder.com/400x600/cccccc/666666?text=Photo+1",
    "https://via.placeholder.com/400x600/cccccc/666666?text=Photo+2",
    "https://via.placeholder.com/400x600/cccccc/666666?text=Photo+3",
    "https://via.placeholder.com/400x600/cccccc/666666?text=Photo+4",
    "https://via.placeholder.com/400x600/cccccc/666666?text=Photo+5",
  ],
  verified: true,
  height: "5'6\"",
  lifestyle: {
    drinking: "Socially",
    smoking: "Never",
    workout: "Often",
    diet: "Vegetarian",
  },
  socials: {
    instagram: "@emma_designs",
    spotify: "Emma's Playlist",
  },
  interests: [
    { name: "Photography", icon: Camera },
    { name: "Hiking", icon: Mountain },
    { name: "Coffee", icon: Coffee },
    { name: "Travel", icon: Plane },
    { name: "Yoga", icon: Dumbbell },
    { name: "Art", icon: Palette },
    { name: "Music", icon: Music },
    { name: "Cooking", icon: Utensils },
  ],
}

export default function MatchDetails() {
  const toast = useToast()
  const globalCtx = useContext(GlobalContext)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [expandedSection, setExpandedSection] = useState("bio")
  const [userDataDb,setUserDataDb] = useState();
  const { id } = useParams();
  const [likesNotifications, setLikesNotifications] = useState();
  const [matchesNotifications, setMatchesNotifications] = useState();
  const navigate = useNavigate()
  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false)
  const { celebrateFromLikeResponse } = useMatchCelebration()

      function handleOnChat(channelUrl){
        navigate(`/messages/${channelUrl}`);
    }

        async function handleOnMatchClick() {

                  try {
                          const likeResponse = await AddLike({
                              LikerProfileId: user.id,
                              LikedProfileId: id,
                          });
                          if (await celebrateFromLikeResponse(likeResponse, userDataDb, { assumeMutualMatch: shouldRenderMatchButton })) {
                            return;
                          }

                      toast({
                        title: 'like sent',
                        status: 'success',
                        duration: 10000,
                        isClosable: true,
                        position: "bottom-left",
                    });
                          console.log('Like response:', likeResponse);
                  } catch (error) {
                      console.error('Error in handleOnLike:', error);
                      if (isLikeLimitError(error)) {
                        globalCtx.updateLikeCount(FREE_DAILY_LIKE_LIMIT);
                        toast({
                          title: "Daily like limit reached",
                          description: "Upgrade to Premium for unlimited likes.",
                          status: "info",
                          duration: 5000,
                          isClosable: true,
                          position: "bottom-left",
                        });
                      }
                  }

        }

   // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
        useEffect(() => {
          async function GetNotifications() {
            try {
              const likesNotifications = await GetLikesNotifications(user.id);
              const matchesNotifications = await GetMatchesNotifications(user.id);
              setLikesNotifications(likesNotifications);
              setMatchesNotifications(matchesNotifications);
              console.log('Likes Notifications:', likesNotifications);
              console.log('Matches Notifications:', matchesNotifications);
            } catch (error) {
              toast({
                  position: "bottom-left",
               title: "Failed to fetch user details.",
                description: error.message || "Something went wrong.",
                status: "error",
                duration: 15000,
                isClosable: true,
              });
            }
          }
          GetNotifications();
        }, []);

// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
useEffect(() =>{
    console.log(id);
    GetUserInfo();
},[]);

async function GetUserInfo(){
    const user = await GetUserById(id)
    setUserDataDb(user);
    console.log("/////USERDETAPI", user);
}

console.log("/////USERDETAILState", userDataDb);

  // Handle click on image segments
  const handleImageClick = (e) => {
    e.stopPropagation()
    setIsImageViewerOpen(true)
  }

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev === userDataDb.images.length - 1 ? 0 : prev + 1))
  }

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? userDataDb.images.length - 1 : prev - 1))
  }

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section)
  }

    if (!userDataDb) {
    return <Spinner />;
  }

  let userIds ;
  let shouldRenderMatchButton = false;
  let MatchesUserIds ;
  let ShouldRenderMessageButton = false;
  let sendBirdUri;
 

  console.log('Match Nots',matchesNotifications)

  if(matchesNotifications){
  const matchFound = matchesNotifications.filter(x => x.user.id === id);
  sendBirdUri = matchFound?.[0]?.sendBirdUri ?? "defaultUri";
  }

  if(matchesNotifications){
  MatchesUserIds = matchesNotifications.map(notif => notif.user.id);
  userIds = likesNotifications.map(notif => notif.user.id);
  ShouldRenderMessageButton = MatchesUserIds?.includes?.(id) || (MatchesUserIds?.includes?.(id) && !userIds?.includes?.(id));
  console.log ('Should Render Message Button :', ShouldRenderMessageButton)
  }

  if(likesNotifications){
    MatchesUserIds = matchesNotifications.map(notif => notif.user.id);
  userIds = likesNotifications.map(notif => notif.user.id);
  shouldRenderMatchButton = userIds?.includes?.(id) && !MatchesUserIds?.includes?.(id);
  }



  return (
    <Center w={'100%'}>
      <div className="min-h-screen bg-gray-50 w-full">
        <div className="max-w-7xl mx-auto p-4">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <CdnButton onClick={() => navigate(-1)} variant="outline" size="icon" className="rounded-full hover:bg-gray-100">
                <ArrowLeft className="h-4 w-4" />
              </CdnButton>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 max-w-6xl mx-auto">
            {/* Left Side - Tinder-style Image Gallery */}
            <div className="lg:col-span-2 relative">
              <div className="relative aspect-[3/4] w-full lg:max-w-md mx-auto bg-black rounded-2xl overflow-hidden shadow-lg">
                {/* Image */}
                <div className="relative h-full w-full cursor-pointer" onClick={handleImageClick}>
                  <Image
                    src={
                      userDataDb?.images?.[currentImageIndex]
                        ? resolveImageUrl(userDataDb.images[currentImageIndex]) ?? "/placeholder.svg"
                        : resolveProfileImageUrl(userDataDb) ?? "/placeholder.svg"
                    }
                    alt={`${userData.name}'s profile`}
                    fill
                    className="object-cover"
                    priority
                  />

                  {/* Gradient overlay at bottom */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                  {/* Top indicators */}
                  <div className="absolute top-3 left-3 right-3 flex gap-1 z-10">
                    {userDataDb?.images.map((_, index) => (
                      <div
                        key={index}
                        className={`h-1 flex-1 rounded-full transition-all duration-300 ${
                          index === currentImageIndex ? "bg-white" : "bg-white/30"
                        }`}
                      />
                    ))}
                  </div>

                  {/* Navigation arrows */}
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation()
                      prevImage()
                    }}
                    className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-1.5 transition-all duration-200 backdrop-blur-sm z-10"
                  >
                    <ChevronLeft className="w-4 h-4" />
                  </button>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation()
                      nextImage()
                    }}
                    className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-1.5 transition-all duration-200 backdrop-blur-sm z-10"
                  >
                    <ChevronRight className="w-4 h-4" />
                  </button>

                  {/* Bottom content overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white z-10">
                    <div className="space-y-1">
                      <div className="flex items-center gap-2">
                        <h1 className="text-2xl font-bold">
                          {userDataDb?.firstName}, {userDataDb?.age}
                        </h1>
                        <PremiumVerifiedBadge user={userDataDb} size={20} />
                      </div>

                      <div className="flex items-center gap-1">
                        <MapPin className="w-3 h-3" />
                        <span className="text-xs">{userDataDb?.country}</span>
                      </div>

                      <div className="space-y-1">
                        <div className="flex items-center gap-1">
                          <Briefcase className="w-3 h-3" />
                          <span className="text-xs">{userDataDb.occupation}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <GraduationCap className="w-3 h-3" />
                          <span className="text-xs">{userDataDb.education}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Profile Information */}
            <div className="lg:col-span-3 space-y-3 w-full max-w-full overflow-x-hidden p-1.5">
              {/* Header Info */}
              <div className="bg-white rounded-xl p-4 shadow-sm border-b border-gray-200 w-full max-w-full" style={{ background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 w-full max-w-full">
                  <div>
                    <h2 className="text-xl font-bold text-gray-900 flex items-center gap-1">
                      {userDataDb?.firstName}, {userDataDb.age}
                      <PremiumVerifiedBadge user={userDataDb} size={18} />
                    </h2>
                    <div className="flex items-center text-gray-500 text-xs">
                      <MapPin className="w-3 h-3 mr-1" />
                      <span>{userDataDb.country ? userDataDb.country.toLowerCase() : ''}</span>
                    </div>
                  </div>
                  <div className="flex gap-2 w-full sm:w-auto">
                      <Button 
                        onClick={()=>handleOnChat(sendBirdUri)} 
                        size="sm" 
                        className="text-white font-medium flex-1 sm:flex-none"
                        style={{ 
                          background: 'linear-gradient(145deg, #34D399 0%, #10B981 100%)',
                          border: '1px solid rgba(52, 211, 153, 0.2)'
                        }}
                        _hover={{
                          background: 'linear-gradient(145deg, #10B981 0%, #059669 100%)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(52, 211, 153, 0.2)'
                        }}
                      >
                        Message
                      </Button>
                  </div>
                </div>
              </div>

              {/* Bio - Collapsible */}
              <div className="rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-300" 
                   style={{ 
                     background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
                     transform: expandedSection === "bio" ? 'scale(1.02)' : 'scale(1)'
                   }}>
                <button
                  className="flex justify-between items-center w-full p-2.5 pl-6 text-left hover:bg-gray-50/50 transition-all duration-200 hover:scale-[1.02] hover:shadow-sm rounded-lg"
                  onClick={() => toggleSection("bio")}
                >
                  <div className="flex items-center">
                    <h3 className="text-sm font-semibold text-gray-900">About Me 👋</h3>
                  </div>
                  {expandedSection === "bio" ? (
                    <ChevronUp className="w-4 h-4 text-gray-500 transition-transform duration-200" />
                  ) : (
                    <ChevronDown className="w-4 h-4 text-gray-500 transition-transform duration-200" />
                  )}
                </button>
                {expandedSection === "bio" && (
                  <div className="p-2.5 pt-0 border-t border-gray-100 animate-fadeIn">
                    <p className="text-gray-700 text-sm leading-relaxed">{userDataDb?.bio}</p>
                  </div>
                )}
              </div>

              {/* Interests - Collapsible */}
              <div className="rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-300"
                   style={{ 
                     background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
                     transform: expandedSection === "interests" ? 'scale(1.02)' : 'scale(1)'
                   }}>
                <button
                  className="flex justify-between items-center w-full p-2.5 pl-6 text-left hover:bg-gray-50/50 transition-all duration-200 hover:scale-[1.02] hover:shadow-sm rounded-lg"
                  onClick={() => toggleSection("interests")}
                >
                  <div className="flex items-center">
                    <h3 className="text-sm font-semibold text-gray-900">Interests 🎯</h3>
                  </div>
                  {expandedSection === "interests" ? (
                    <ChevronUp className="w-4 h-4 text-gray-500 transition-transform duration-200" />
                  ) : (
                    <ChevronDown className="w-4 h-4 text-gray-500 transition-transform duration-200" />
                  )}
                </button>
                {expandedSection === "interests" && (
                  <div className="p-2.5 pt-0 border-t border-gray-100 animate-fadeIn">
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mt-2">
                      {userDataDb.interests.map((interest) => (
                        <ProfileDetailsInterestBadge key={interest.interestName} interest={interest}/>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Lifestyle - Collapsible */}
              <div className="rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-300"
                   style={{ 
                     background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
                     transform: expandedSection === "lifestyle" ? 'scale(1.02)' : 'scale(1)'
                   }}>
                <button
                  className="flex justify-between items-center w-full p-2.5 pl-6 text-left hover:bg-gray-50/50 transition-all duration-200 hover:scale-[1.02] hover:shadow-sm rounded-lg"
                  onClick={() => toggleSection("lifestyle")}
                >
                  <div className="flex items-center">
                    <h3 className="text-sm font-semibold text-gray-900">Lifestyle 🎧</h3>
                  </div>
                  {expandedSection === "lifestyle" ? (
                    <ChevronUp className="w-4 h-4 text-gray-500 transition-transform duration-200" />
                  ) : (
                    <ChevronDown className="w-4 h-4 text-gray-500 transition-transform duration-200" />
                  )}
                </button>
                {expandedSection === "lifestyle" && (
                  <div className="p-2.5 pt-0 border-t border-gray-100 animate-fadeIn">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
                      <div className="flex items-center justify-between text-xs p-2 rounded-lg transition-all duration-200 hover:shadow-md"
                           style={{ background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                        <span className="text-gray-500">Drinking</span>
                        <span className="font-medium text-gray-900">{userDataDb.drinking}</span>
                      </div>
                      <div className="flex items-center justify-between text-xs p-2 rounded-lg transition-all duration-200 hover:shadow-md"
                           style={{ background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                        <span className="text-gray-500">Smoking</span>
                        <span className="font-medium text-gray-900">{userDataDb.smoking}</span>
                      </div>
                      <div className="flex items-center justify-between text-xs p-2 rounded-lg transition-all duration-200 hover:shadow-md"
                           style={{ background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                        <span className="text-gray-500">Workout</span>
                        <span className="font-medium text-gray-900">{userDataDb.workout}</span>
                      </div>
                      <div className="flex items-center justify-between text-xs p-2 rounded-lg transition-all duration-200 hover:shadow-md"
                           style={{ background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                        <span className="text-gray-500">Religion</span>
                        <span className="font-medium text-gray-900">{userDataDb.religion}</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Quick Stats */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                <div className="rounded-xl p-2.5 shadow-sm border border-gray-100 text-center transition-all duration-200 hover:shadow-md"
                     style={{ background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                  <div className="text-xs text-gray-500">Occupation</div>
                  <div className="text-sm font-medium text-gray-900">{userDataDb.occupation}</div>
                </div>
                <div className="rounded-xl p-2.5 shadow-sm border border-gray-100 text-center transition-all duration-200 hover:shadow-md"
                     style={{ background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                  <div className="text-xs text-gray-500">Education</div>
                  <div className="text-sm font-medium text-gray-900">{userDataDb.education}</div>
                </div>
                <div className="rounded-xl p-2.5 shadow-sm border border-gray-100 text-center transition-all duration-200 hover:shadow-md"
                     style={{ background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                  <div className="text-xs text-gray-500">Location</div>
                  <div className="text-sm font-medium text-gray-900">{userDataDb.country}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Full Screen Image Viewer Modal */}
        <Modal isOpen={isImageViewerOpen} onClose={() => setIsImageViewerOpen(false)} size="full">
          <ModalOverlay bg="blackAlpha.900" />
          <ModalContent 
            bg="transparent" 
            boxShadow="none" 
            maxW="100vw" 
            maxH="100vh"
            m={0}
            p={0}
          >
            <ModalBody 
              p={0} 
              position="relative" 
              display="flex" 
              alignItems="center" 
              justifyContent="center"
              h="100vh"
              w="100vw"
            >
              {/* Close button */}
              <IconButton
                aria-label="Close viewer"
                icon={<X className="w-6 h-6" />}
                position="absolute"
                top={4}
                right={4}
                onClick={() => setIsImageViewerOpen(false)}
                bg="blackAlpha.500"
                color="white"
                _hover={{ bg: "blackAlpha.600" }}
                zIndex={2}
              />

              {/* Image */}
              <div className="relative w-full h-full flex items-center justify-center">
                <img
                  src={
                      userDataDb?.images?.[currentImageIndex]
                      ? resolveImageUrl(userDataDb.images[currentImageIndex]) ?? "/placeholder.svg"
                      : resolveProfileImageUrl(userDataDb) ?? "/placeholder.svg"
                  }
                  alt={`${userData.name}'s profile`}
                  className="max-w-full max-h-full object-contain"
                  style={{ maxHeight: '90vh' }}
                />
              </div>

              {/* Navigation arrows */}
              <IconButton
                aria-label="Previous image"
                icon={<ChevronLeft className="w-8 h-8" />}
                position="absolute"
                left={4}
                top="50%"
                transform="translateY(-50%)"
                onClick={(e) => {
                  e.stopPropagation()
                  prevImage()
                }}
                bg="blackAlpha.500"
                color="white"
                _hover={{ bg: "blackAlpha.600" }}
                zIndex={2}
              />
              <IconButton
                aria-label="Next image"
                icon={<ChevronRight className="w-8 h-8" />}
                position="absolute"
                right={4}
                top="50%"
                transform="translateY(-50%)"
                onClick={(e) => {
                  e.stopPropagation()
                  nextImage()
                }}
                bg="blackAlpha.500"
                color="white"
                _hover={{ bg: "blackAlpha.600" }}
                zIndex={2}
              />

              {/* Image counter */}
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-blackAlpha.500 text-white px-3 py-1 rounded-full text-sm">
                {currentImageIndex + 1} / {userDataDb?.images?.length}
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    </Center>
  )
}